import { flatten } from "lodash";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap"
import Dropzone from "react-dropzone";
import IWebsite from "../../interfaces/IWebsite";
import WebsitesApiService from "../../services/websitesApiService";
import LoadingScreen from "../screens/loadingScreen";

interface IProps {
    website: IWebsite,
    onHide(): void,
    onUploaded(imageIds: string[]): void,
}

const websitesApiService = new WebsitesApiService();

export const UploadImageModal = (props: IProps) => {

    const { onHide, website, onUploaded } = props;
    const [uploading, setUploading] = useState(false);

    useEffect(() => {

        return websitesApiService.cancelRequests();
    }, [])

    async function handleUploadFile(files: File[]) {

        let ids: string[] = [];

        await Promise.all(files.map(file => {
            setUploading(true);

            return websitesApiService.uploadImage(website.id, file)
                .then(data => {
                    const images = data.records.images.items;
                    return images;
                });
        })
        ).then((imagesImages) => {
            const images = flatten(imagesImages);

            setUploading(false);
            onUploaded(images.map(image => image.id));
            onHide();
        })
    }

    return (
        <Modal animation={false} size="xl" centered={true} show onHide={onHide}>
            <Modal.Header closeButton onHide={onHide.bind(this)}>
                <Modal.Title>
                    <h5>Nahrát obrázky</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {uploading ? <LoadingScreen withCard={false} />
                    :
                    <Dropzone onDrop={(files) => handleUploadFile(files)}>
                        {({ getRootProps, getInputProps, }) => (
                            <section>
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} accept="image/x-png,image/jpeg" />
                                    <div className="dropzone-area my-4">
                                        <h3>Vybrat obrázky</h3>
                                    </div>
                                </div>
                            </section>
                        )}
                    </Dropzone>}
            </Modal.Body>
        </Modal>)
}